<template>
    <div class="pop-buttons" v-show="actionData.col" :style="{left:clientX+'px',top:clientY+'px'}" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <p>
            <el-button class="mini-button" :loading="isLoading" @click="addFilter" type="primary" size="mini" plain>{{actionData.type=='add'?'添加筛选':'追加筛选'}}</el-button>
            <el-button class="mini-button" @click="copyValue" type="primary" size="mini" plain>复制内容</el-button>
        </p>
        <p class="mt6">
            <el-button class="mini-button" :loading="isLoading" @click="addFilterAndFirstGroup" type="primary" size="mini" plain>{{actionData.type=='add'?'添加筛选':'追加筛选'}}并作为第一维度</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "TableTdPop",
        props:{
            actionData:Object,
            isLoading:Boolean,
        },
        data(){
            return {
                isShow:false,
                timer:null,
                seconds:15,
            }
        },
        computed:{
            clientX(){

                if(!this.actionData.event) return 0;
                return this.actionData.event.clientX + 200 > document.body.clientWidth ? this.actionData.event.clientX - 200 -10 :this.actionData.event.clientX+10;
            },
            clientY(){
                if(!this.actionData.event) return 0;
                return this.actionData.event.clientY + 80 > document.body.clientHeight ? this.actionData.event.clientY - 80 : this.actionData.event.clientY-5;
            }
        },
        methods:{
            addFilter(){
                this.$emit('add',this.actionData.col,this.actionData.row);
            },
            addFilterAndFirstGroup(){
                this.$emit('add-and-first',this.actionData.col,this.actionData.row);
            },
            mouseEnter(){
                this.$emit('mouse-enter');
            },
            mouseLeave(){
                this.$emit('mouse-leave');
            },
            copyValue(){
                this.$emit('copy',this.actionData.col,this.actionData.row);
            }
        }
    }
</script>

<style scoped>
    .pop-buttons{
        /*display: none;*/
        width: 220px;
        background-color: #fff;
        position: fixed;
        z-index: 100;
        border: solid 1px #dedede;
        border-radius: 5px;
        padding: 10px;
        box-shadow:3px 3px 5px 1px rgba(0,0,0,0.3)
    }
    .pop-wrap:hover .pop-buttons{
        /*display: block;*/
    }

    .mini-button{
        padding: 5px 10px;
    }
</style>
